module.exports = __webpack_public_path__ + "static/media/lidl.8ee00499.png";